import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { MentionsInput, Mention } from 'react-mentions'
import { CommentPreview } from 'previews/';
import { Button } from 'components';
import styles from './NewComment.scss';

const NewComment = ({
    onComment,
    onCancel,
    onClose,
    placeholder,
    cancelButtonText,
    commentButtonText,
    user,
    noComments,
    commentContent,
    mentionsAllowed,
    mentionableUsersArray
}) => {
    const [comment, setComment] = useState('');
    const [commentPlainValue, setCommentPlainValue] = useState('');
    const [mentionsArray, setMentionsArray] = useState([]);

    useEffect(() => {
        if (commentContent) {
            setComment(commentContent);
        }
    }, [commentContent]);
    
    const formatMentions = (mentions) => {
        setMentionsArray(mentions.map(mention => ({
            name: mention.display.replace('@', ''),
            email: mention.id
        })));
    };

    const displayFormatedMention = (id, display) => `@${display}`;

    const handleMentionInputChange = (event, value, plainValue, mentions) => {
        setComment(value);
        setCommentPlainValue(plainValue);
        formatMentions(mentions);
    };

    const resetCommentForm = () => {
        setComment('');
        if (mentionsAllowed) {
            setMentionsArray([]);
            setCommentPlainValue('');
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if(comment) {
            onComment(mentionsAllowed ?
                commentPlainValue : comment,
                mentionsArray
            );
            resetCommentForm();
        }
    };

    const handleCancel = () => {
        resetCommentForm();
        onCancel();
        onClose();
    };

    return (
        <div className={styles.newCommentContainer}>
            { noComments &&
                <Typography
                    variant='subtitle2'
                    className={styles.userName}
                    data-testid='comments-popOver__empty-comments-header'
                >
                    { user }
                </Typography>
            }
            {
                mentionsAllowed ?
                    <MentionsInput
                        value={comment}
                        placeholder={placeholder}
                        onChange={handleMentionInputChange}
                        className='mentionInput'
                        classNames={styles}
                        allowSpaceInQuery
                        allowSuggestionsAboveCursor
                        data-testid='comments-popOver__new-comment-input'
                    >
                        <Mention
                            data={mentionableUsersArray}
                            displayTransform={displayFormatedMention}
                            className={styles.mention}
                            data-testid='comments-popOver__new-comment-input__mention'
                        />
                    </MentionsInput> :
                    <CommentPreview
                        placeholder={placeholder}
                        value={comment}
                        onChange={(value) => setComment(value)}
                        className={styles.commentInput}
                        inputProps={{'data-testid': 'comments-popOver__new-comment-input'}}
                    />
            }
            <div className={styles.actionButtons}>
                { comment &&
                    <Button
                        className={styles.cancelButton}
                        onClick={handleCancel}
                        data-testid='comments-popOver__reset-comment-button'
                    >
                        { cancelButtonText }
                    </Button>
                }
                <Button
                    disabled={!comment}
                    color='primary'
                    variant='contained'
                    type='submit'
                    className={styles.commentButton}
                    onClick={handleSubmit}
                    data-testid='comments-popOver__submit-comment-button'
                >
                    { commentButtonText }
                </Button>
            </div>
        </div>
    );
};

NewComment.propTypes = {
    onComment: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    cancelButtonText: PropTypes.string,
    commentButtonText: PropTypes.string.isRequired,
    user: PropTypes.string,
    noComments: PropTypes.bool.isRequired,
    commentContent: PropTypes.string,
    mentionsAllowed: PropTypes.bool,
    mentionableUsersArray: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        display: PropTypes.string
    }))
};

NewComment.defaultProps = {
    commentContent: '',
    mentionsAllowed: false,
    mentionableUsersArray: []
};

export default NewComment;
